import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { LoadOrderListItem } from 'src/app/domain/models/LoadOrder';
import { InstructiveInfo, MasterLoad, Pallet, PalletInstructiveFormat } from 'src/app/domain/models/Pallet';

import { MenuItem, MessageService } from 'primeng/api';
import { AuthGateway } from 'src/app/application/gateway/AuthGateway';
import { ProfileService } from 'src/app/application/service/ProfileService';
import { ProfileContactInfo } from 'src/app/domain/models/Profile';
import { ActivatedRoute, Router } from '@angular/router';
import { Routes } from 'src/app/infrastructure/routes';
import { ImportOrderDetailGateway } from 'src/app/application/gateway/ImportOrderDetailGateway';
import { PdfUtils } from 'src/app/ui/util/pdf.utils';
import { BasicUser } from 'src/app/domain/models/User';

@Component({
  selector: 'app-instructive-view',
  templateUrl: './instructive-view.component.html',
  styleUrls: ['./instructive-view.component.css'],

})
export class InstructiveViewComponent {

  profile: ProfileContactInfo | undefined

  loading: boolean = false

  importOrderDetailGuid: string = ""

  instructiveInfo: InstructiveInfo | undefined

  loadingBtnPacking: boolean = false

  loadingBtnInstructive: boolean = false

  private intervalId: any;

  profileUser: BasicUser | undefined

  breadcrumbItems: MenuItem[] = []
  breadcrumbHomeItem: MenuItem = {}

  isProgram: boolean = false
  customClass = ' text-container-custom'


  constructor(
    private _router: Router,
    private _messageService: MessageService,
    public translateService: TranslateService,
    private _authService: AuthGateway,
    private _profileService: ProfileService,
    private _importOrderDetailService: ImportOrderDetailGateway,
    private _activatedRoute: ActivatedRoute,
    public translate: TranslateService
  ) {
    this._activatedRoute.params.subscribe(params => {
      this.importOrderDetailGuid = params['importOrderDetailGuid']
    })
    this._activatedRoute.queryParams.subscribe(queryParams => {
      this.isProgram = queryParams['isProgram'] === 'true';
    })
  }

  ngOnInit(): void {

    this.profileUser = this._authService.getUser()

    if(this.isProgram){
      let breadcrumbMenuItemLabel1 = "Load's Instructive"
      let breadcrumbHomeMenuItemLabel = 'Reports'

      if(this.profileUser) {
        switch(this.profileUser.lang) {
          case 'en':
            breadcrumbMenuItemLabel1 = "Load's Instructive"
            breadcrumbHomeMenuItemLabel = 'Reports'
            break
          case 'es':
            breadcrumbMenuItemLabel1 = 'Instructivo de carga'
            breadcrumbHomeMenuItemLabel = 'Reportes'
            break
        }
      }

      this.breadcrumbItems = [{ label: breadcrumbMenuItemLabel1}]
      this.breadcrumbHomeItem = { label: breadcrumbHomeMenuItemLabel, routerLink: '/' + Routes.userLoadOrdersProgram };

    }
    else{

      let breadcrumbMenuItemLabel1 = "Load's Instructive"
      let breadcrumbHomeMenuItemLabel = 'My loads'

      if(this.profileUser) {
        switch(this.profileUser.lang) {
          case 'en':
            breadcrumbMenuItemLabel1 = "Load's Instructive"
            breadcrumbHomeMenuItemLabel = 'My loads'
            break
          case 'es':
            breadcrumbMenuItemLabel1 = 'Instructivo de carga'
            breadcrumbHomeMenuItemLabel = 'Mis cargas'
            break
        }
      }

      this.breadcrumbItems = [{ label: breadcrumbMenuItemLabel1, disabled: true}]
      this.breadcrumbHomeItem = { label: breadcrumbHomeMenuItemLabel, routerLink: '/' + Routes.userLoadOrders };

    }



    this.loadInstructiveInfo()
    this.startPeriodicTask();

    this._profileService.getContactInfo().subscribe({
      next: (v) => {
        this.profile =  v
      },
      error: (e) => {
        console.log(e)
        this._messageService.add({ severity: 'error',
          summary: this.translateService.instant('MessageService.Summary.FailedAction'),
          detail: this.translateService.instant('MessageService.ProfileMessageService.SingleRetrieveError') });
      },
    })
  }

  ngOnDestroy() {
    this.stopPeriodicTask();
  }

  startPeriodicTask() {
    this.intervalId = setInterval(() => {
      this.executeTask();
    }, 3600000); // 1 horas en milisegundos (1 * 60 * 60 * 1000)
  }

  executeTask() {
    this.loadInstructiveInfo()
  }

  stopPeriodicTask() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }


  loadInstructiveInfo(){
    this.loading = true;
    this._importOrderDetailService.getInstructivePreview(this.importOrderDetailGuid).subscribe({
      next: (v) => {
        this.loading = false;
        this.instructiveInfo = v

      },
      error: (e) => {
        this.loading = false
        console.log(e)
        this._messageService.add({ severity: 'error',
          summary: 'Acción fallida',
          detail: 'No se pudieron recuperar los detalles de la orden de importación.' });
      },
    })
  }


  downloadPackingListApi(importOrderDetailGuid: string){
    this.loadingBtnPacking = true;
    this._importOrderDetailService.getDownloadPackingList(importOrderDetailGuid).subscribe(
      {
        next: (resultBlob: any) => {

          PdfUtils.downloadPdf(resultBlob.body, "Packing List");
          this.loadingBtnPacking = false;
          },
          error: (e) => {
            this.loading = false;
            this._messageService.add({ severity: 'error',
              summary: this.translate.instant('MessageService.Summary.FailedAction'),
              detail:  this.translate.instant('UserPages.PackingListView.ErrorDownloadPDF') })
          },
          complete: () => {
            this.loadingBtnPacking = false;
          }
      }
    )
  }

  // get totalBoxesPerPallets() {
  //   return this.instructiveInfo?.palletsInstructive?.reduce((sum, product) => sum + product.boxesPerPallets, 0);
  // }

  // get totalPallets() {
  //   return this.instructiveInfo?.palletsInstructive?.reduce((sum, product) => sum + product.pallets, 0);
  // }

  getInstructivePdf(importOrderDetailGuid: string) {

    this.loadingBtnInstructive = true;
    this._importOrderDetailService.getInstructiveDocumentPdf(importOrderDetailGuid).subscribe(
      {
        next: (resultBlob: any) => {
          const contentDisposition = resultBlob.headers.get('content-disposition');
          let nombreArchivo = 'Instructive';
          if (contentDisposition) {
              const match = contentDisposition.match(/filename=([A-Za-z0-9\-]+);/);
              if (match && match[1]) {
                  nombreArchivo =  nombreArchivo + '-' + match[1];
              }

              PdfUtils.downloadPdf(resultBlob.body, nombreArchivo);
          }else{
            PdfUtils.downloadPdf(resultBlob.body, nombreArchivo);
          }

          this.loadingBtnInstructive = false;
          },
          error: (e) => {
            this.loadingBtnInstructive = false;
            this._messageService.add({ severity: 'error',
              summary: this.translate.instant('MessageService.Summary.FailedAction'),
              detail: 'Can not download pdf file.' })
          }
      })
  }

  addSpaceString(value: string) {
    return value.replace(/ /g, " - ");
  }

}

